import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

import { getProject } from "modules/projects/actions";

import AssemblyDetails from "./form/1_AssemblyDetails";
import WeldDetails from "./form/2_WeldDetails";
import { Button, Block, Tabs, Tab, f7, BlockTitle } from "framework7-react";
import _, { get } from "lodash";
import InspectionDetails from "./form/3_InspectionDetails";
import { FieldArray } from "react-final-form-arrays";
import { ReactDropzone } from "modules/4_final_form/mobile";

const mapStateToProps = (state, ownProps) => {
  const { project_id } = ownProps;
  const project = state.projects[project_id];

  return {
    project: project,
  };
};

let ProjectQaWedlingInspectionForm = (props) => {
  const [activeTab, setActiveTab] = useState(0);
  const { handleSubmit, formLabel, errors, project_id } = props;

  useEffect(() => {
    props.getProject(props.project_id);
  }, []);

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const togglePrev = () => {
    toggle(activeTab - 1);
  };
  const toggleNext = () => {
    toggle(activeTab + 1);
  };

  const AssemblyDetailsErrors = _.get(errors, "assemblies", {});

  const WeldDetailsFields = [
    "access_restriction_id",
    "surface_condition_id",
    "viewing_condition_id",
    "welding_type_id",
    "fillet_sizes_attributes",
    "welding_processes_attributes",
    "welding_stages_attributes",
    "welders_attributes",
    "welding_procedure_id",
    "welding_standard_id",
  ];

  const WeldDetailsErrors = _.pick(errors, WeldDetailsFields);

  return (
    <form>
      <Tabs>
        <Tab tabActive={activeTab == 0}>
          <AssemblyDetails {...props} />
          <Block className="grid grid-cols-2 grid-gap">
            <div />
            <Button
              size="sm"
              color="green"
              fill
              onClick={() => {
                if (_.isNotEmpty(AssemblyDetailsErrors) || _.isArray(AssemblyDetailsErrors)) {
                  f7.dialog.alert("Please fill in all required fields");
                  handleSubmit();
                } else {
                  toggleNext();
                }
              }}
            >
              Next
            </Button>
          </Block>
        </Tab>
        <Tab tabActive={activeTab == 1}>
          <WeldDetails {...props} />
          <Block className="grid grid-cols-2 grid-gap">
            <Button color="red" fill size="sm" onClick={togglePrev}>
              Previous
            </Button>

            <Button
              size="sm"
              color="green"
              fill
              onClick={() => {
                if (_.isEmpty(WeldDetailsErrors)) {
                  toggleNext();
                } else {
                  f7.dialog.alert("Please fill in all required fields");
                  handleSubmit();
                }
              }}
            >
              Next
            </Button>
          </Block>
        </Tab>
        <Tab tabActive={activeTab == 2}>
          <InspectionDetails {...props} />
          <Block className="grid grid-cols-2 grid-gap">
            <Button color="red" fill size="sm" onClick={togglePrev}>
              Previous
            </Button>

            <Button size="sm" color="green" fill onClick={toggleNext}>
              Next
            </Button>
          </Block>
        </Tab>
        <Tab tabActive={activeTab == 3}>
          <BlockTitle>General Photos</BlockTitle>
          <Block>
            <FieldArray component={ReactDropzone} name="attachments_attributes" />
          </Block>
          <Block className="grid grid-cols-2 grid-gap">
            <Button color="red" fill size="sm" onClick={togglePrev}>
              Previous
            </Button>

            <Button size="sm" color="green" fill onClick={handleSubmit}>
              Submit
            </Button>
          </Block>
        </Tab>
      </Tabs>
    </form>
  );
};

export default connect(mapStateToProps, { getProject })(ProjectQaWedlingInspectionForm);
